
const Testimonials = () => {
  return (
    <div className="testimonial">
      <div className="testimonial-title">CLIENT TESTIMONIALS</div>
      <div className="card-section">
        <div className="card-box">
          <div className="testimonial-card">
            <div className="testimonial-name">KAREN YU, TREASURER</div>
            <div className="testimonial-position">Nephridge County Community Association</div>
            <div className="testimonial-image">
              <img src="assets/img/testimonial-1.png" alt="" />
            </div>
            <div className="testimonial-quote">
              "As the Treasurer for our HOA, and with experience managing finances for a multi-million dollar corporation, working with ABM has been a pleasure. Their attention to detail and proactive approach have made managing our community's finances much easier. They provide clear financial reports, expert advice, and ensure that we stay on track. The ABM team is responsive, reliable, and truly cares about the success and stability of our community."
            </div>
          </div>
        </div>
        <div className="card-box active-bg">
          <div className="testimonial-card">
            <div className="testimonial-name active-color">Craig Forry</div>
            <div className="testimonial-position active-color">President, Porter Ranch Estates</div>
            <div className="testimonial-image">
              <img src="assets/img/testimonial.png" alt="" />
            </div>
            <div className="testimonial-quote active-color">
              "As the President of our HOA and a professional attorney, I’ve worked with numerous service providers, but ABM Property Management truly stands out. Their professionalism, attention to detail, and deep understanding of legal and financial matters have made them an invaluable partner to our community. They handle everything from everyday operations to complex legal issues with ease, and their responsiveness and commitment to excellence give me confidence that our community is in great hands. ABM consistently goes above and beyond, making our job as Board Members much easier."
            </div>
          </div>
        </div>
        <div className="card-box">
          <div className="testimonial-card">
            <div className="testimonial-name">Cordelia Kelsey</div>
            <div className="testimonial-position">President of Mariposa at Plum Canyon HOA</div>
            <div className="testimonial-image">
              <img src="assets/img/testimonial-1.png" alt="" />
            </div>
            <div className="testimonial-quote">
              "ABM Property Management has been a fantastic asset to our community. Their professionalism, attention to detail, and exceptional customer service have made my role as President so much easier. They handle our finances with precision, respond quickly to any inquiries, and provide invaluable knowledge of HOA laws and insurance matters. Their expertise ensures everything runs smoothly, and I highly recommend them!"
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;